import App from './App.svelte';

window.evo3DMobile = function ($el, content, video) {
	let app = new App({
		target: $el,
		props: {
			content,
			video
		}
	});
	return app;
};